import React, { useState } from "react";
import Table from "../../../components/Table2";
import Tabs from "../../../components/Tabs";
import OverflowingText from "../../../components/OverflowingText/OverflowingText";
import transactionIcon from "../../../assets/images/svg/transactions.svg";
import { observer } from "mobx-react-lite";
import {
  commaSeperated,
  displayUnit,
  getDisplayDate,
  showDataWithRupeeDashOrZero,
} from "../../../utils/functions";
//import { useNavigate } from "react-router";
import UserStore from "../../../store/UserStore";
import { ttRedColorArr } from "../../../utils/constants";
import { Link } from "react-router-dom";

const ViewAllLink = ({ selectedTab }) => {
  const corpActionData = {
    to: "/reports/transactions-corporate-action-report",
    from: "transactions-corporate-action-report",
  };

  const transactionsData = {
    to: "/reports/transactions-report",
    from: "transactions-report",
  };

  const linkData =
    selectedTab === "corpaction" ? corpActionData : transactionsData;

  return (
    <Link
      to={linkData.to}
      state={{
        from: linkData.from,
      }}
      className="view_all_wrapper flex is-align-items-center view_all_custom_div"
      aria-label={`View all ${linkData.from}`}
    >
      <p>View All</p>
      <div className="custom_view_all table-view-all" aria-hidden="true">
        <svg
          width="6.17"
          height="10"
          viewBox="0 0 10 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1.88 16L0 14.12L6.10667 8L0 1.88L1.88 0L9.88 8L1.88 16Z" />
        </svg>
      </div>
    </Link>
  );
};

const dateCellRenderer = (data) => {
  return (
    <p className="date_cell" style={{ whiteSpace: "nowrap", fontSize: 14 }}>
      {" "}
      {getDisplayDate(data)}
    </p>
  );
};

const qtyCellRenderer = (data) => {
  return (
    <p style={{ fontFamily: "Roboto" }} className="qty_cell">
      {data ? commaSeperated(data) : ""}
    </p>
  );
};

const navCellRenderer = (data) => {
  return (
    <p style={{ fontFamily: "Roboto" }} className="qty_cell">
      {showDataWithRupeeDashOrZero(data, false)}
    </p>
  );
};

const tvaCellRenderer = (data) => {
  return (
    <p className="qty_cell">
      <span className="value">
        {data.value ? commaSeperated(data?.value) : ""}&nbsp;
      </span>
      <span className="unit">{displayUnit(data.value_type)}</span>
    </p>
  );
};

const ExDateCellRenderer = (data) => {
  return <p className="qty_cell">{getDisplayDate(data)}</p>;
};
const amtCellRenderer = (data) => {
  return (
    <p className="qty_cell">
      <span className="value">₹</span>&nbsp;
      <span className="value">
        {data.value ? commaSeperated(data?.value) : "-"}{" "}
      </span>
      <span className="unit">{`${displayUnit(data.value_type) || ""}`}</span>
    </p>
  );
};
const actionCellRenderer = (data) => {
  return <p className="action_cell home_corp_action">{data?.toUpperCase()}</p>;
};
const ttypeCellRenderer = (data) => {
  return (
    <p
      className={`ttype_cell ${
        ttRedColorArr.includes(data.toLowerCase()) && "red_text"
      }`}
    >
      {data?.toUpperCase()}
    </p>
  );
};

const asscCellRenderer = (data) => {
  return <p className="assc_cell">{data?.toUpperCase()}</p>;
};

const nameCellRenderer = (data) => {
  return <OverflowingText text={data} buttonStyle={{ right: "-4px" }} />;
};

const nameCellRendererForCA = (data) => {
  return (
    <OverflowingText
      text={data}
      textClassName="CA_transactions_ins_name"
      ellipsisTextClassName="CA_transactions_ins_name"
    />
  );
};

const corporateActionsColumns = [
  {
    label: "Instrument Name",
    key: "security_name",
    width: "40%",
    cellRenderer: nameCellRendererForCA,
  },
  {
    label: "Date",
    key: "exDate",
    width: "20%",
    cellRenderer: ExDateCellRenderer,
  },
  {
    label: "Amount",
    key: "amount",
    width: "16%",
    cellRenderer: amtCellRenderer,
  },
  {
    label: "Action",
    key: "type",
    width: "20%",
    cellRenderer: actionCellRenderer,
  },
];

const Transactions = observer(() => {
  const transactionsData =
    UserStore?.portfolio?.clientRecentTransactions?.clientTransactions;
  const corporateActionsData =
    UserStore?.portfolio?.clientCorporateActions?.corporateActionList;

  const [selectedTab, setTab] = useState("trans");
  //const navigate = useNavigate();

  const columTransaction = [
    {
      label: "Date",
      key: "transaction_date",
      // width: "149px",
      cellRenderer: dateCellRenderer,
    },
    {
      label: "Name",
      key: "security_name",
      // width: "200px",
      cellRenderer: nameCellRenderer,
    },
    {
      label: "Quantity",
      key: "quantity",
      // width: "145px",
      cellRenderer: qtyCellRenderer,
    },
    {
      label: "Price",
      key: "rate",
      classn: "nav_table_head",
      // width: "141px",
      cellRenderer: navCellRenderer,
    },
    {
      label: "Transaction Value",
      key: "amount",
      // width: "174px",
      cellRenderer: tvaCellRenderer,
    },
    {
      label: "Transaction Type",
      key: "type",
      // width: "175px"
      cellRenderer: ttypeCellRenderer,
    },
    {
      label: "Asset Class",
      key: "asset_class",
      cellRenderer: asscCellRenderer,
    },
  ];

  return (
    <div className="home_page_transaction_container">
      <div className="flex is-align-items-center is-justify-content-space-between transaction_tabs_header">
        <div className="flex is-align-items-center">
          <img src={transactionIcon} alt="trasnactionIccon" />
          <div className="transaction_heading">Transactions</div>
        </div>
        <ViewAllLink selectedTab={selectedTab} />
        {/* <div
          className="view_all_wrapper flex is-align-items-center view_all_custom_div"
          onClick={() => {
            if (selectedTab === "corpaction") {
              navigate(`/reports/transactions-corporate-action-report`, {
                state: { from: "transactions-corporate-action-report" },
              });
            } else {
              navigate(`/reports/transactions-report`, {
                state: { from: "transactions-report" },
              });
            }
          }}
        >
          <p>View All</p>
          <button className="custom_view_all" aria-label="View All">
            <svg
              width="6.17"
              height="10"
              viewBox="0 0 10 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.88 16L0 14.12L6.10667 8L0 1.88L1.88 0L9.88 8L1.88 16Z"
                fill=""
              />
            </svg>
          </button>
        </div> */}
      </div>
      <Tabs
        onSelect={(value) => {
          setTab(value);
        }}
        tabs={[
          {
            label: "Recent Transactions",
            value: "trans",
          },
          {
            label: "Recent Corporate Actions",
            value: "corpaction",
          },
        ]}
      />
      <div className="transaction_table_container">
        {selectedTab === "trans" && (
          <Table
            data={
              transactionsData?.length && transactionsData?.length > 10
                ? transactionsData?.slice(0, 5)
                : transactionsData
            }
            columns={columTransaction}
            tableClass="custom_table2 transac1 grey-border-table"
            EmptyState={
              <div className="tax_lots_empty flex is-justify-content-center is-align-items-center is-fullheight is-flex-direction-column">
                <div className="empty_state_img_wrapper">
                  <img
                    width="100%"
                    src={transactionIcon}
                    alt="transaction icon"
                  />
                </div>
                <div className="empty_state_txt">
                  You have no recent
                  {selectedTab === "trans"
                    ? " transactions "
                    : " corporate actions "}
                  to show here
                </div>
              </div>
            }
          />
        )}
        {selectedTab === "corpaction" && (
          <Table
            data={
              corporateActionsData?.length && corporateActionsData?.length > 10
                ? corporateActionsData?.slice(0, 5)
                : corporateActionsData
            }
            EmptyState={
              <div className="tax_lots_empty flex is-justify-content-center is-align-items-center is-fullheight is-flex-direction-column">
                <div className="empty_state_img_wrapper">
                  <img
                    width="100%"
                    src={transactionIcon}
                    alt="transaction icon"
                  />
                </div>
                <div className="empty_state_txt">
                  You have no recent
                  {selectedTab === "trans"
                    ? " transactions "
                    : " corporate actions "}
                  to show here
                </div>
              </div>
            }
            columns={corporateActionsColumns}
            tableClass="custom_table3 grey-border-table"
            name="recCA"
          />
        )}
      </div>
    </div>
  );
});

export default Transactions;
